import {createContext} from 'react';

export const ModelContext = createContext(null)
export const LikelihoodContext = createContext(null)
export const AltpriorContext = createContext(null)
export const NullpriorContext = createContext(null)

